<template>
  <b-modal
    :id="updateModalId"
    no-close-on-backdrop
    ok-title="確認"
    centered
    header-bg-variant="primary"
    ok-only
    @hidden="handleHide"
  >
    <template #modal-title>
      <h4 class="m-0 model-header">
        {{ selectedItem.id ? '編輯' : '新增' }}作業分類
      </h4>
    </template>

    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <b-form
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <!-- 部門 -->
        <b-form-group
          v-if="!selectedItem.id"
          label-for="department_id"
        >
          <template #label>
            <div class="d-flex justify-content-between align-items-center">
              <label class="mb-0">
                部門
                <span class="text-danger">*</span>
              </label>

              <!-- <span>
                <div
                  v-b-tooltip.hover.v-secondary
                  title="部門設定"
                  class="d-flex align-items-center actions-link-btn-sm"
                  @click="() => { $refs.todoTypeDepartmentExplorerModal.getData(null) }"
                >
                  <b-img
                    src="/admin/images/table/settings.svg"
                    class="actions-link-btn-image"
                    rounded
                  />
                </div>
              </span> -->
            </div>
          </template>

          <v-select
            v-model="classData.department_id"
            :options="departmentsOptions"
            :clearable="false"
            label="name"
            :reduce="option => option.id"
            placeholder="請選擇部門"
          >
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                沒有<em>{{ search }}</em> 的相關結果
              </template>

              <div v-else>
                <small>暫無資料</small>
              </div>
            </template>
          </v-select>
        </b-form-group>

        <!-- 作業分類名稱 -->
        <validation-provider
          #default="{ errors }"
          name="作業分類名稱"
          rules="required"
        >
          <b-form-group label-for="name">
            <template #label>
              <label class="mb-0">
                作業分類名稱
                <span class="text-danger">*</span>
              </label>
            </template>

            <b-form-input
              id="name"
              v-model="classData.name"
              autofocus
              :state="errors.length > 0 ? false : null"
              trim
              :placeholder="classData.name ? classData.name : '請輸入作業分類名稱'"
            />

            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <div>
          <label>作業分類說明</label>
          <b-form-textarea
            v-model="classData.description"
            :placeholder="classData.description ? classData.description : '請輸入作業分類說明'"
            :state="classData.description.length <= maxChar ? null : false"
            rows="5"
          />
          <small
            class="textarea-counter-value float-right"
            :class="classData.description.length > maxChar ? 'bg-danger' : ''"
          >
            <span class="char-count">{{ classData.description.length }}</span> / {{ maxChar }}
          </small>
        </div>
      </b-form>
    </validation-observer>

    <template #modal-footer>
      <div class="w-100 text-right">
        <b-button
          variant="primary"
          :disabled="isBusy"
          @click="handleOk"
        >
          <span v-if="!isBusy">確認</span>

          <b-spinner
            v-else
            small
          />
        </b-button>
      </div>
    </template>

    <!-- <department-explorer-modal
      ref="todoTypeDepartmentExplorerModal"
      department-explorer-id="todoTypeDepartmentExplorerModal"
      :is-hiden-emit="true"
      :use-callback-data="false"
      @emit-hidden-function="resetMetaList"
    /> -->

  </b-modal>
</template>

<script>
// API
import { ref } from '@vue/composition-api'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'

// UI
import {
  BForm, VBToggle, BButton, BSpinner, BFormInvalidFeedback, BFormGroup, BFormInput, BFormTextarea,
  VBTooltip, // BImg,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

// Component
import formValidation from '@core/comp-functions/forms/form-validation'
// import DepartmentExplorerModal from '@/layouts/components/Modal/department-modal/departmentModal.vue'
import { useTodoTypeModal, useModalSetting } from '../useModal'
import { useAlert } from '@/libs/mixins/index'

export default {
  components: {
    // BImg,
    BForm,
    // BFormGroup,
    BButton,
    BSpinner,
    BFormInvalidFeedback,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    // BInputGroup,
    // BInputGroupAppend,
    // BFormSpinbutton,

    vSelect,
    ValidationProvider,
    ValidationObserver,
    // DepartmentExplorerModal,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
    'b-tooltip': VBTooltip,
  },
  props: {
    selectedItem: {
      type: Object,
      required: true,
    },
    updateModalId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      required,
      missingFields: [],
      maxChar: 255,
    }
  },
  methods: {
    // 按下彈窗關閉
    handleHide(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.resetBrandData()
      this.isBusy = false
      this.$nextTick(() => {
        this.$bvModal.hide(this.updateModalId)
      })
    },

    // 按下彈窗確認
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()

      // 判斷必填欄位是否填寫
      const requiredFields = {
        name: '作業分類名稱',
      }

      this.missingFields = []

      for (let i = 0; i < Object.keys(requiredFields).length; i += 1) {
        if (this.classData[Object.keys(requiredFields)[i]] === null || this.classData[Object.keys(requiredFields)[i]] === '') {
          this.missingFields.push({
            lable: Object.values(requiredFields)[i],
            value: Object.keys(requiredFields)[i],
          })
        }
      }

      if (this.classData.description.length > this.maxChar) {
        this.useAlertToast(false, '作業分類說明字數超過上限')
        return
      }

      if (this.missingFields.length > 0) {
        this.useAlertToast(false, `${this.missingFields[0].lable}不得為空`)
        return
      }

      this.isBusy = true

      if (this.selectedItem.id) {
        this.setTodoTypeUpdate({
          type_id: this.selectedItem.id,
          data: {
            ...this.classData,
          },
        })
          .then(response => {
            this.useHttpCodeAlert(response)
            this.$emit('reset-table')
            this.resetBrandData()
            this.$nextTick(() => {
              this.$bvModal.hide(this.updateModalId)
            })
            this.isBusy = false
          })
          .catch(error => {
            this.useHttpCodeAlert(error.response)
            this.isBusy = false
          })
      } else {
        this.setTodoTypeCreate({
          ...this.classData,
        })
          .then(response => {
            this.useHttpCodeAlert(response)
            this.$emit('reset-table')
            this.resetBrandData()
            this.$nextTick(() => {
              this.$bvModal.hide(this.updateModalId)
            })
            this.isBusy = false
          })
          .catch(error => {
            this.useHttpCodeAlert(error.response)
            this.isBusy = false
          })
      }
    },

    // (重新)獲取Meta
    resetMetaList() {
      this.getMetaListData()
        .then(response => {
          const { departments } = response.data.data
          this.departmentsOptions = departments
          const findObject = departments.find(el => el.id === this.selectedItem.department_id)

          if (findObject === undefined) {
            this.classData.department_id = null
          }
        })
    },

    // (獲取)資料
    getData() {
      this.getMetaListData()
        .then(response => {
          const { departments } = response.data.data
          this.departmentsOptions = departments

          const resolveData = {
            ...this.syncObject(this.blankClassData, this.selectedItem),
          }

          const findObject = departments.find(el => el.id === this.selectedItem.department_id)

          if (findObject === undefined) {
            resolveData.department_id = null
          }
          this.classData = resolveData
          this.$bvModal.show(this.updateModalId)
        })
        .catch(() => {
          const resolveData = {
            ...this.syncObject(this.blankClassData, this.selectedItem),
          }
          this.classData = resolveData
          this.$bvModal.show(this.updateModalId)
        })
    },
  },
  setup() {
    localize('tw')

    const {
      setTodoTypeCreate,
      setTodoTypeUpdate,
    } = useTodoTypeModal()

    const {
      isBusy,
      syncObject,
      getMetaListData,
      departmentsOptions,
    } = useModalSetting()

    const {
      useAlertToast,
      useHttpCodeAlert,
    } = useAlert()

    const blankClassData = {
      name: null,
      description: '',
      department_id: null,
    }

    const classData = ref(JSON.parse(JSON.stringify(blankClassData)))

    const resetBrandData = () => {
      classData.value = JSON.parse(JSON.stringify(blankClassData))
      isBusy.value = false
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetBrandData)

    return {
      isBusy,

      classData,
      blankClassData,
      setTodoTypeCreate,
      setTodoTypeUpdate,
      departmentsOptions,

      resetBrandData,
      refFormObserver,
      getValidationState,
      resetForm,

      useHttpCodeAlert,
      useAlertToast,
      syncObject,
      getMetaListData,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss" scoped>
.model-header {
  color: white;
  padding: 5px 0;
}
</style>
